export const passwordStrengthItems: {
  name: string;
  isValid: boolean;
  regex: RegExp;
}[] = [
  {
    name: "PasswordManager.Setup.PasswordHelperChar",
    isValid: false,
    regex: /^.{8,15}$/,
  },
  {
    name: "PasswordManager.Setup.PasswordHelperLower",
    isValid: false,
    regex: /[a-z]/,
  },
  {
    name: "PasswordManager.Setup.PasswordHelperSymbol",
    isValid: false,
    regex: /[\W_]/,
  },
  {
    name: "PasswordManager.Setup.PasswordHelperNumber",
    isValid: false,
    regex: /\d/,
  },
  {
    name: "PasswordManager.Setup.PasswordHelperUpper",
    isValid: false,
    regex: /[A-Z]/,
  },
];
